import { render, staticRenderFns } from "./bills.vue?vue&type=template&id=fabb00a2&"
import script from "./bills.vue?vue&type=script&lang=js&"
export * from "./bills.vue?vue&type=script&lang=js&"
import style0 from "./bills.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports